import React from "react";
import ReactDOM from "react-dom";
import Chart from "react-google-charts";

const data = [
  ["Element", "Density", { role: "style" }],
  ["Jan", 8.94, "#00CF9B"], // RGB value
  ["Feb", 10.49, "#00CF9B"], // English color name
  ["March", 19.3, "#00CF9B"],
  ["Apr", 21.45, "color: #00CF9B"] ,// CSS-style declaration
  ["May", 18.45, "color: #00CF9B"] ,// CSS-style declaration
  ["June", 15.45, "color: #00CF9B"] ,// CSS-style declaration
   // CSS-style declaration
];
export default ()=> {
    return (
      <div>
        <div className=" rounded">
          <h5 className="p-2">Hours and Miles</h5>
        <Chart
          chartType="ColumnChart"
        //   width="400px"
        //   height="400px"
          data={data}
        />
        </div>
      </div>
    );
}
